import {
  FETCH_LIQUIDACIONES_LISTA_SELLERS,
  FETCH_SELLERS_FILTER,
  FETCH_FACTURACIONES,
  FETCH_INTEGRADORES,
  SET_FILTRO_SELLER,
  FETCH_SELLERS,
  FETCH_SELLER,
  EDIT_SELLER,
  FETCH_PROVEEDORES_FILTER
} from './types';
import {
  getSeller,
  fetchSellersApi,
  listSellersParameters,
  getIntegradores,
  getTipoFacturacion,
  getLiquidacionesListaSellers,
  fetchProveedoresApi
} from "../api/axios";


export const fetchIntegradores = () => async dispatch => {
  let array = getIntegradores();
  let integradores;
  array.then(function (value) {
    integradores = value;

    dispatch({
      type: FETCH_INTEGRADORES,
      payload: integradores
    });
  });
}

export const fetchProveedoresFilter = (params) => async dispatch => {
  let options = [];
  let req = fetchProveedoresApi(params);
  req.then((res) => {

    res.elementos.map((proveedor) => options.unshift({ value: proveedor.codigo, label: proveedor.descripcion }));

    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: options
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: []
    });
  });
}

export const setFiltroSeller = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_SELLER,
    payload: filtro
  });
}

export const fetchFacturaciones = () => async dispatch => {
  let array = getTipoFacturacion();
  let facturaciones;
  array.then(function (value) {

    facturaciones = value;
    dispatch({
      type: FETCH_FACTURACIONES,
      payload: facturaciones
    });
  });
}

export const fetchSellers = (Descripcion, CantidadPagina, NumeroPagina) => async dispatch => {
  let array = listSellersParameters(Descripcion, CantidadPagina, NumeroPagina);

  array.then((sellers) => {
    dispatch({
      type: FETCH_SELLERS,
      payload: sellers
    });
  });
}

export const fetchSellersFilter = (params) => async dispatch => {
  let options = [];
  let req = fetchSellersApi(params);
  req.then((res) => {

    res.elementos.map((seller) => options.unshift({ value: seller.codigo, label: seller.razonSocial }));

    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: options
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: []
    });
  });
}

export const fetchSeller = (id) => async dispatch => {

  let seller;
  if (typeof id !== 'undefined') {

    let sellers = getSeller(id);
    sellers.then(function (value) {
      seller = value.elementos[0];
      dispatch({
        type: FETCH_SELLER,
        payload: seller
      });
    });
  } else {
    seller = {
      codigo: '',
      codigoPostal: '',
      cuit: '',
      domicilio: '',
      email: '',
      emailUsuario: '',
      emailDespacho: '',
      estado: '',
      idEstado: 1,
      integrador: 1,
      localidad: '',
      numeroDomicilio: '',
      provincia: '',
      razonSocial: '',
      telefono: '',
      tipoFacturacion: 1,
      urlPushOrdenes: '',
      sufijo: '',
      idEmpresaEnviopack: 0,
      nombreUsuario: '',
      nombreTienda: '',
      logo: '',
      tiendaActiva: false
    }

    dispatch({
      type: FETCH_SELLER,
      payload: seller
    });
  }
}

export const editSeller = (seller) => dispatch => {
  dispatch({
    type: EDIT_SELLER,
    payload: seller
  });
}

export const fetchLiquidacionesListaSellers = () => async dispatch => {
  let array = getLiquidacionesListaSellers();
  array.then(function (value) {
    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: value.listaSellersLiquidaciones
    });
  });
}